import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { UserCheck, X } from "lucide-react";
import CoachAvatar from "@/components/CoachAvatar";

export default function ApprovedCoaches({ room, refreshKey }) {
  const [coaches, setCoaches] = useState([]);
  const load = () => { api.get(`/rooms/${room.id}/approved-coaches`).then((r) => setCoaches(r.data)).catch(() => {}); };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [room.id, refreshKey]);

  const remove = async (c) => {
    try { await api.delete(`/rooms/${room.id}/approved-coaches/${c.id}`); toast.success(`${c.name} retiré des coachs approuvés`); load(); }
    catch { toast.error("Erreur"); }
  };

  return (
    <div className="mt-3" data-testid={`approved-coaches-${room.id}`}>
      <div className="text-[11px] uppercase tracking-wider font-semibold text-slate-500 flex items-center gap-1"><UserCheck className="w-3 h-3" /> Coachs approuvés ({coaches.length})</div>
      <div className="mt-1.5 flex flex-wrap gap-1.5">
        {coaches.map((c) => (
          <span key={c.id} data-testid={`approved-coach-${room.id}-${c.id}`} className="inline-flex items-center gap-1.5 text-xs pl-1 pr-2 py-0.5 rounded-full bg-sky-500/10 text-sky-800 border border-sky-500/20">
            <CoachAvatar coach={c} size="w-5 h-5" textSize="text-[9px]" /> {c.name}
            <button data-testid={`unapprove-${room.id}-${c.id}`} onClick={() => remove(c)} className="text-rose-600" aria-label="Retirer"><X className="w-3 h-3" /></button>
          </span>
        ))}
        {coaches.length === 0 && <span className="text-xs text-slate-500">Aucun — validez une réservation d'un coach ou approuvez-le depuis ses demandes.</span>}
      </div>
    </div>
  );
}
